import React from 'react';

export const SquarePredibase = () => {
  return (
    <>
      <div className="absolute top-0 -left-[1.5rem] h-auto w-[10.5rem]">
        <svg viewBox="0 0 206 2" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M206 1L-3.09944e-06 0.999982"
            stroke="url(#paint0_linear_2413_20596)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2413_20596"
              x1="206"
              y1="-0.499669"
              x2="17.6061"
              y2="38.7924"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#EAEAEA" stop-opacity="0" />
              <stop
                offset="0.500822"
                stop-color="#B4B4B4"
                stop-opacity="0.467642"
              />
              <stop offset="1" stop-color="#848484" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="absolute bottom-0 -left-[1.5rem] h-auto w-[10.5rem]">
        <svg viewBox="0 0 206 2" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M206 1L-3.09944e-06 0.999982"
            stroke="url(#paint0_linear_2413_20596)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2413_20596"
              x1="206"
              y1="-0.499669"
              x2="17.6061"
              y2="38.7924"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#EAEAEA" stop-opacity="0" />
              <stop
                offset="0.500822"
                stop-color="#B4B4B4"
                stop-opacity="0.467642"
              />
              <stop offset="1" stop-color="#848484" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="absolute -top-[0.7rem] -left-[3.95rem] w-full h-[10.5rem]">
        <svg
          viewBox="0 0 7 197"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
        >
          <path d="M3 0L2.99999 197" stroke="url(#paint0_linear_2413_20586)" />
          <path d="M3.46094 10V16" stroke="#FF622B" />
          <path d="M6.92188 13L-0.00120187 13" stroke="#FF622B" />
          <path d="M3.46094 160V166" stroke="#FF622B" />
          <path d="M6.92188 163L-0.00120187 163" stroke="#FF622B" />
          <defs>
            <linearGradient
              id="paint0_linear_2413_20586"
              x1="1.50026"
              y1="-16.9465"
              x2="40.8132"
              y2="180.159"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#EAEAEA" stop-opacity="0" />
              <stop
                offset="0.532358"
                stop-color="#B4B4B4"
                stop-opacity="0.467642"
              />
              <stop offset="1" stop-color="#848484" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="absolute -top-[0.7rem] -right-[3.95rem] w-full h-[10.5rem]">
        <svg
          viewBox="0 0 7 197"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
        >
          <path d="M3 0L2.99999 197" stroke="url(#paint0_linear_2413_20586)" />
          <path d="M3.46094 10V16" stroke="#FF622B" />
          <path d="M6.92188 13L-0.00120187 13" stroke="#FF622B" />
          <path d="M3.46094 160V166" stroke="#FF622B" />
          <path d="M6.92188 163L-0.00120187 163" stroke="#FF622B" />
          <defs>
            <linearGradient
              id="paint0_linear_2413_20586"
              x1="1.50026"
              y1="-16.9465"
              x2="40.8132"
              y2="180.159"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#EAEAEA" stop-opacity="0" />
              <stop
                offset="0.532358"
                stop-color="#B4B4B4"
                stop-opacity="0.467642"
              />
              <stop offset="1" stop-color="#848484" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </>
  );
};
